var _b;
import { createSlice } from '@reduxjs/toolkit';
import { LANGUAGES } from "../../../../constants";
export var initialChatBubbleState = {
    hasInteracted: false,
    isChatMinimized: true,
    isSurveyMinimized: false,
    languageCode: LANGUAGES.EN
};
var chatBubbleSlice = createSlice({
    name: 'CHAT_TRIGGER',
    initialState: initialChatBubbleState,
    reducers: {
        interactWithChatBot: function (state) {
            state.hasInteracted = true;
        },
        minimizeChat: function (state, _b) {
            var payload = (_b === void 0 ? null : _b).payload;
            state.isChatMinimized = payload === null ? !state.isChatMinimized : payload;
        },
        minimizeSurvey: function (state, _b) {
            var payload = (_b === void 0 ? null : _b).payload;
            state.isSurveyMinimized = payload === null ? !state.isSurveyMinimized : payload;
        },
        languageCode: function (state, _b) {
            var payload = _b.payload;
            state.languageCode = payload;
        }
    },
});
export var interactWithChatBot = (_b = chatBubbleSlice.actions, _b.interactWithChatBot), minimizeChat = _b.minimizeChat, minimizeSurvey = _b.minimizeSurvey, languageCode = _b.languageCode;
export var hasAlreadyInteractedWithChatBot = function (state) { return state.chat_trigger.hasInteracted; };
export var isChatMinimized = function (state) { return state.chat_trigger.isChatMinimized; };
export var isSurveyMinimized = function (state) { return state.chat_trigger.isSurveyMinimized; };
export var currentLanguage = function (state) { return state.chat_trigger.languageCode; };
export default chatBubbleSlice.reducer;
